module.exports = __webpack_public_path__ + "static/media/cart-arrow-down.d42d5d31.svg";